import moment from 'moment'

const DateFilter = {
  name: 'date',
  fn: (value: Date|string|number) : string => {
    console.log('Date filter', value)

    // warning parameters can be numbers strings and objects...

    if (!value) return ''

    const DEFAULT_DATE_FORMAT = 'M/D/YYYY h:mm a'

    // Timestamp
    if (value instanceof Date) {
      return moment(value).format(DEFAULT_DATE_FORMAT)
    }

    if (typeof value === 'string') {
      const date = moment(value, 'ddd MMM DD YYYY HH:mm:ss Z')
      return date.format(DEFAULT_DATE_FORMAT)
    } else {
      return moment(value).format(DEFAULT_DATE_FORMAT)
    }

  }
}

export default DateFilter
